import { Button } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
export var changePasswordSuccess = function changePasswordSuccess(t) {
  return {
    severity: 'success',
    message: t('Your password has been changed'),
    duration: 'medium'
  };
};
export var saveSuccess = function saveSuccess(t) {
  return {
    severity: 'success',
    message: t('Your changes have been saved'),
    duration: 'medium'
  };
};
export var submitFailure = function submitFailure(message, onRetry) {
  return {
    severity: 'error',
    message: message,
    duration: 'medium',
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onRetry,
      children: /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return t('Retry');
        }
      })
    })
  };
};
export var changePasswordFailure = function changePasswordFailure(onRetry, t) {
  return submitFailure(t('Sorry, we were unable to change your password'), onRetry);
};
export var saveFailure = function saveFailure(onRetry, t) {
  return submitFailure(t('Sorry, we were unable to save your changes'), onRetry);
};
export var resetPasswordFailure = function resetPasswordFailure(onRetry, t) {
  return submitFailure(t('Sorry, we were unable to reset your changes'), onRetry);
};
export var deleteAccountFailure = function deleteAccountFailure(onRetry, t) {
  return submitFailure(t('Sorry, we were unable to delete your account'), onRetry);
};